import Vue from 'vue';
import VueIntercom from 'vue-intercom';
import VueSimpleAlert from "vue-simple-alert";
import Vuelidate from 'vuelidate';
import VueRouter from "vue-router";
import LoadingOverlay from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import Webstore from "./components/checkouts/webstore/pages/webstore";
import ReviewCart from './components/checkouts/webstore/pages/review-cart';
import Shipping from './components/checkouts/checkout/pages/shipping';
import Review from './components/checkouts/checkout/pages/review';
import Payment from './components/checkouts/checkout/pages/payment';
import Confirm from './components/checkouts/checkout/pages/confirm';
import UpdatePayment from './components/checkouts/checkout/pages/update-payment';

import axios from 'axios';

// import sentry via npm instead of cdn
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import { CaptureConsole } from '@sentry/integrations';

import { analyticsPage } from '../vue/plugins/segment';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import store from './store/store';
import { routes } from './routes';

const version = require('../../package.json').version;
const applicationName = require('../../package.json').name;

export const router = new VueRouter({
    routes,
    mode: 'history'
});

let localDevelopment = process.env.NODE_ENV !== "production"
Vue.config.devtools = localDevelopment

// anyone can change localDevelopment to true if you would like to see error logs in a built version on localhost 5000
if (localDevelopment) {
    Vue.config.errorHandler = (err, vm, info) => {
        console.error("Custom Error Handler: ", err, vm, info)
    };
    Vue.config.warnHandler = function (err, vm, info) {
        console.warn('Custom Warn handler: ', err, vm.name, info);
    };
} else {
    // new sentry implementation based on the latest version of sentry/vue
    Sentry.init({
        dsn: 'https://2fb472ccf101450bb2a4bab2b526f5ac@o212792.ingest.sentry.io/1339924',
        release: `${applicationName}@${version}`,
        Vue,
        attachProps: true,
        logErrors: false,
        tracesSampleRate: 1.0,
        attachStacktrace: true,
        tracingOptions: {trackComponents: true},
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: ["elasticbeanstalk", "samsara.com", /^\//],
            }),

            new CaptureConsole({
                levels: ['error']
            })
        ]
    });
}

Vue.use(VueSimpleAlert);
Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(VueIntercom, { appId: 'g18dp3o8' });
Vue.use(VueReCaptcha, { siteKey: '6LfCy_MZAAAAAOYoaD-PgnPKlBUGq8iH0xqt3YnI' });


router.afterEach(async (to) => {
    if (to.path.includes('/webstore')) {
        let segments = await axios('/webstore/get-sfdc-segment-data');
        return analyticsPage({ 
            "path": to.path, 
            "name": to.name, 
            "page_name": to.name, 
            "sfdcOwnerRole": segments.data.sfdcOwnerRole, 
            "sfdcSegmentC": segments.data.sfdcSegmentC,
        });
    }
    analyticsPage({ "path": to.path, "name": to.name, "page_name": to.name });
})

Vue.component('loading-overlay', LoadingOverlay);
Vue.component("webstore", Webstore);
Vue.component('review-cart', ReviewCart);
Vue.component('shipping', Shipping);
Vue.component('review', Review);
Vue.component('payment', Payment);
Vue.component('confirm', Confirm);
Vue.component('update-payment', UpdatePayment);

new Vue({
    el: '#vue',
    router,
    store
});

